export default "__VITE_ASSET__dCsrZ_XN__"